import { FC } from "react";

export const CreateProjectIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="24" height="24" fill="url(#createProject)" />
    <defs>
      <pattern
        id="createProject"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_7882_4311" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_7882_4311"
        width="90"
        height="90"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAGH0lEQVR4nO2dSYwUVRjHf58aBiLuJs4SSYwLEUW2qIAHFU8CCepBL3IzLtEDiZHxoJK4HIwKUQ+CHjQxUYJxYRNNNBMXMHgwgoAEgnFBFtkkYGAYmL+H6tHOTFd1Vb16r6d76pf05fWr7/vq35W39fdeQUlJSUlJSUlJSUlJyTDF8lwkqQuYB8wFrgAuB84tMK4i6AOOAL8A3wIrge/M7ExDo0qDpA5JSyX1qTnZL+kJSaNDa5f6iZY0G3gfON9fOMH4HVhgZh+HcnhWmkqSHgZW0RoiA4wDPpT0rKRczWdW6jqpPMmrgLP9h9MQ3gPuNzP5dJIotKQOYDut8yTH8ZyZPePTQb2mYxHNI/IJYDFwEzC28rkWeBD4os61T0m62294MUjqUvOMLn6VNKHO/dwqaUeCjd/kcTSS9ETfBZzjy3GBnABmm9m2pEpm9hUwHfgmpso44LGCY6uPpE9DPIoF8ErG+7pY0s4YW/skpRqJZSXJ6JU+HHpgeZbKZnaYqN2uxWXADOeIapAkdIcPhx74OesFZtYDfBnz9Ty3cGqTJPR5PhwWjZkdz3npipjymXljScJLe9QkfB1TfpUPZyNZ6N0x5Rf6cJYk9B4fDgvmz7wXJjQ5bXltJpEk9Ls+HBZMM8QIJE9IBub+84HOALFkYQ+RyIsaHUhanJYIJdVc8TKzIEuProSMfyR3hkEphQ5EKXQgSqEDUQodiFLoQJRCB6IUOhBB/6rKOkGIq5+V4TCBKp/oQJRCB6IUOhCl0IEohQ5E0FFH1t4/wGjhLWBL5fMHcLTyKZwRvR4dkrLpCEQpdCBKoQNRCh2IVlvreN7Mnk4ZSxtR+tftwERgPNBOlMAu4B9gL7AD2Az0EG2f680YkztxebS+69egX9LjKWOeJulNSX9nsD/AEUnLJE3No1duihIua/1BnJH0QIpYp0r6PIuqdVgnaXJe7TIRF4Hv+oPorhPjGEmvSjqdScZ09ElaIt8bROO8+65fRWJKmKTxkjZnli87P0q62kXLROK8+q5fYZek2B1jkm6U9Fcu2fJxSFJsbnVLTsEl3Uy05W1sYNfHgTvM7PvBX7Sc0JLGA+uBSxoUwkFgppntrC5sqQmLok5pOY0TGeBSon3mY6oLW0po4EUg75DrFLCQKEW5E+iulOVhIvBCzmuHEtcrFOYgWyxT5TaEW1jDZreDvT5Jk4q6uZoUYjx7LK6TkSHb/SS1O9pcW9TN1cRj/ZpbiBVNq53IGnNK+iVNgeZro9fElD8UNIr0GJVdukGHd471t5rZ9TXqtAH7gQvqBpyAx2ypI0B7Mz3RG2LKb8FRZM9cBExvJqG3xpTfFjSKfMxqJqG3xJQXM4Tyyw1OV2ftwX0gaVuK3r9X0Xl3hZ3YoOgMwIUV2/WIe0hSOxsOQh9McaNDJiMF+k8zqTnQ9ItKknqBUXWqdZrZXk/+24n+W0yi17WNPhbjPPTyZD18/vCpzgN0FTrul7zO0W4Wav7Yg5jv0X8a22lijEfxB1y95mQ4WwxpO8NuSYUdHiCps2IzSGf4aIzhkwr0D7GkT1LcaF0S7BfBR65Nx0rgdI3yNmCNwoi9KYAPVzY5CW1mu4G3Y77uAjZKel3SDPnrIHs82S2SHufeWFG7tx3/p4ptM7MhnayiRaV9OJ6F5HFR6TDQ4TwFN7M9wL2A7yPdJ0gacuhhJRfuA8++XVhhZqcKWesws8+ABUB/EfYSuDOmfKlnv3kRsKx4q9JcSUcL6qlrsT7B9zpH20OGfoqGcC6sLlzkquA6FGVc+joSeVqM38mOPofk8El60sFen6SJ3oSuCrJL0iOS1iqaVBxzCLqadxJ8LnGw+9+kRtkmI3G8VB1bS+2eUpRAswGY0uBQNgPTzezEQEEzLfzXxcxOAvcRpWU1igPAPdUiQ4sJDVDJeZtDlHAYmuPAHDPb1QDfjUGNSdv1csj3sEfS1YqSxH3zg2pMpkYUkkZLWiw/w80+SS+rAe/eGrZImqRoqNlfgMD9klYrxDi5WZE0RdEb7A7nEPiQpDeUY/m3pcbRWZA0iui9LLOI8i6uIdrQObAKeYz/N3T+RPTyhY1mlitn+l8grqjCYfLiCwAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

export const CreateProjectBlueIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <mask
      id="mask0_15325_13156"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="url(#pattern0)" />
    </mask>
    <g mask="url(#mask0_15325_13156)">
      <rect width="24" height="24" fill="#080F6C" />
    </g>
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_15325_13156" transform="scale(0.0111111)" />
      </pattern>
      <image
        id="image0_15325_13156"
        width="90"
        height="90"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const ProjectDetailsIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59922 7.20156H20.3992V9.60156H9.59922V7.20156ZM9.59922 3.60156H22.7992V6.00156H9.59922V3.60156ZM1.19922 3.60156H8.39922V10.8016H1.19922V3.60156ZM9.59922 16.8016H20.3992V19.2016H9.59922V16.8016ZM9.59922 13.2016H22.7992V15.6016H9.59922V13.2016ZM1.19922 13.2016H8.39922V20.4016H1.19922V13.2016Z"
        fill="white"
      />
    </svg>
  );
};

export const PaymentInfoIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_11073_10439)">
        <path
          d="M0 12.6094V22.4531H4.40625V12.6094H0Z"
          fill="#292E73"
          fillOpacity="0.82"
        />
        <path
          d="M14.4871 0L8.28906 9.82317C9.27569 9.7958 10.2577 9.93366 11.3171 10.3077C12.3678 8.75972 14.2054 8.14275 15.4848 8.95181C16.7838 9.77203 17.0129 11.7477 16.0126 13.3778L18.1881 15.1755L18.2 15.1894L24.0012 6.01087L14.4871 0ZM17.4252 8.51372L18.1757 7.32375L15.7972 5.82342L15.0474 7.01198L13.8581 6.26147L15.3591 3.88294L20.1148 6.88566L18.6138 9.26353L17.4252 8.51372Z"
          fill="#292E73"
          fillOpacity="0.82"
        />
        <path
          d="M14.8967 12.4572C15.3754 11.5397 15.331 10.5193 14.7335 10.1419C14.1555 9.77476 13.2404 10.1271 12.6172 10.9052C13.0332 11.1395 13.0898 11.1303 14.704 12.298L14.8967 12.4572Z"
          fill="#292E73"
          fillOpacity="0.82"
        />
        <path
          d="M17.2094 16.1867L13.8766 13.4305C13.2156 12.9523 12.5406 12.4882 12.5406 12.4882C11.3594 11.6586 9.98125 11.2227 8.51875 11.2227C8.22339 11.2227 7.92817 11.2367 7.67505 11.2789C6.64994 11.4038 6.05308 11.688 5.875 11.7458V22.0968L10.7407 24.0008L16.9141 19.182C17.4063 18.8024 17.6875 18.2258 17.7156 17.607C17.7297 17.0867 17.5469 16.5805 17.2094 16.1867Z"
          fill="#292E73"
          fillOpacity="0.82"
        />
      </g>
      <defs>
        <clipPath id="clip0_11073_10439">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CompleteIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 3V21H5.25V15H20.25V3H3.75ZM5.25 4.5H7.5V6.75H9.75V4.5H12V6.75H14.25V4.5H16.5V6.75H18.75V9H16.5V11.25H18.75V13.5H16.5V11.25H14.25V13.5H12V11.25H9.75V13.5H7.5V11.25H5.25V9H7.5V6.75H5.25V4.5ZM7.5 9V11.25H9.75V9H7.5ZM9.75 9H12V6.75H9.75V9ZM12 9V11.25H14.25V9H12ZM14.25 9H16.5V6.75H14.25V9Z"
        fill="#292E73"
        fillOpacity="0.82"
      />
    </svg>
  );
};

export const CourseCustomizeIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.9999V7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999Z"
        stroke="#292E73"
        strokeOpacity="0.82"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.26953 6.96094L11.9995 12.0109L20.7295 6.96094"
        stroke="#292E73"
        strokeOpacity="0.82"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.08V12"
        stroke="#292E73"
        strokeOpacity="0.82"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
